export default "__VITE_ASSET__B1zgLho2__"